<template>
  <v-container fluid grid-list-md>
    <v-progress-linear id="registrationLoad" v-if="!isProfileLoaded" color="blue" class="mt-0" indeterminate />
    <v-layout v-else justify-center row wrap>
      <v-flex d-flex xs12 md12 lg11 pa-1>
        <v-layout row wrap>
          <v-flex d-flex xs12 md6>
            <v-card>
              <v-card-title class="pb-0">
                <h2 class="headline mb-0">Account Details</h2>
                <v-spacer/>
                <span v-show="isSaved" class="green--text">Saved!</span>
                <v-btn small outline :loading="saving" color="success" style="min-width:50px;" :disabled="!hasMetaChanged" @click="saveChanges()">Save</v-btn>
              </v-card-title>
              <v-card-text pt-0>
                <v-layout row wrap>
                  <v-flex xs12>
                    <h3>Personal Information</h3>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Given Name"
                      placeholder="Submit your First Name"
                      v-model="firstName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md8>
                    <v-text-field
                      label="Family Name"
                      placeholder="Submit your First Name"
                      v-model="lastName"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Primary Contact Number"
                      placeholder="Your Phone/Mobile Number"
                      v-model="phoneNumber"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md8>
                    <v-text-field
                      label="Email"
                      placeholder="Your Email Address"
                      v-model="email"
                    ></v-text-field>
                  </v-flex>
                  <v-divider class="orange sectionDivider mb-2" />
                  <v-flex xs12>
                    <h3>Address</h3>
                  </v-flex>
                  <v-flex xs12 sm6 md8>
                    <v-text-field
                      label="Street"
                      placeholder="Add Your Street Address"
                      v-model="street"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Postcode"
                      minLength="4"
                      mask="####"
                      placeholder="Your Post Code"
                      v-model="postcode"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md8>
                    <v-text-field
                      label="Suburb"
                      placeholder="Add Your Suburb"
                      v-model="suburb"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      label="State"
                      :items="stateItems"
                      v-model="state"
                    ></v-select>
                  </v-flex>
                  <v-divider class="orange mb-2 sectionDivider" />
                  <v-flex xs12>
                    <h3>Secondary Contact (optional)</h3>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Contact Number"
                      placeholder="Add a Secondary Contact Number Here"
                      v-model="secondNumber"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      label="Contact Name"
                      placeholder="Name of Secondary Contact"
                      v-model="secondName"
                    ></v-text-field>
                  </v-flex>
                  <v-divider class="orange mb-2 sectionDivider" />
                  <v-flex xs12>
                    <h3>Family Riders</h3>
                    <p small class="mb-0">Your Family Riders can only be updated during membership registration/renewals</p>
                  </v-flex>
                  <v-layout row wrap v-for="item in family" :key="item.firstName">
                    <v-flex xs12 md5>
                      <v-text-field
                        label="First Name"
                        placeholder=""
                        readonly
                        v-model="item.firstName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        label="Last Name"
                        placeholder=""
                        readonly
                        v-model="item.lastName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md2>
                      <v-text-field
                        label="Bike Number"
                        disabled
                        v-model="item.bikeNo"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
             </v-card>
          </v-flex>
          <v-flex d-flex xs12 md6>
            <v-card v-if="user">
              <v-card-title class="pb-0">
                <h2 class="headline mb-0">Membership Details</h2>
                <v-spacer/>
                <v-btn v-if="hasRegistered" :disabled="disableRenewBtn" small outline color="success" @click="goto('/register')" class="ma-0">
                  Renew Membership
                </v-btn>
              </v-card-title>
              <v-card-text class="pt-2 pb-0">
                <v-layout row wrap pt-0>
                  <v-flex xs12>
                    <h3 class="subheading" v-if="subscription && subscription.membershipNo">Membership Number: {{ `#${('0000' + subscription.membershipNo).slice(-4)}` }}</h3>
                    <h3 class="subheading">Account Created: {{formatDate(profile.accountCreated, 'since')}}</h3>
                    <h3 class="subheading">Status: <span class="memberStatus" :class="memberStatusClass()">{{memberStatus()}}</span></h3>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-text v-if="subscription && subscription.current">
                <v-divider class="orange mb-2 sectionDivider" />
                <v-layout row wrap>
                  <v-flex xs6>
                    <h3>Current Membership</h3>
                  </v-flex>
                  <v-flex xs6 text-xs-right>
                    <v-btn :loading="pdfloading" small outline color="success" @click="downloadCertificate()" style="float:right;">Download Certificate</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="isMembershipExpired()" pa-0>
                  <v-flex xs12 pa-0 ma-0>
                    <v-alert type="error" value=true class="pa-2" >
                      <p class="subheading ma-0 pa-0">Your Membership Requires Renewal! Click the button above to renew it.</p>
                    </v-alert>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-else-if="isMembershipClose()" pa-0>
                  <v-flex xs12 pa-0 ma-0>
                    <v-alert type="warning" value=true class="pa-2">
                      <p class="subheading ma-0 pa-0">Your 12 Month Membership will need to be renewed soon. Renew at any time by clicking the above button</p>
                    </v-alert>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6 pr-2>
                    <v-text-field
                      readonly
                      label="Membership Type"
                      :value="(subscription.type === 'life') ? 'MCTC Life Membership': 'MCTC Standard Membership'"
                    />
                  </v-flex>
                  <v-flex xs12 md6 pr-2>
                    <v-text-field
                      readonly
                      label="Paid"
                      placeholder="No Information"
                      :value="membershipPaymentPrice(subscription.current.price)"
                    />
                  </v-flex>
                  <v-flex xs12 md6 pr-2>
                    <v-text-field
                      readonly
                      label="Activated On"
                      :value="formatDate(subscription.current.subscriptionStarts, 'words')"
                    />
                  </v-flex>
                  <v-flex xs12 md6 pr-2>
                    <v-text-field
                      readonly
                      :error-messages="renewalError()"
                      label="Renewal Payment Due"
                      :value="formatDate(subscription.current.subscriptionEnds, 'words')"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <h3>Volunteer Schedule</h3>
                  </v-flex>
                  <v-flex xs12 pa-0>
                    <v-card pa-0 flat>
                      <v-card-title class="pa-0 cardTitle grey lighten-3">
                        <v-layout row wrap pa-1 pb-2>
                          <v-flex xs8 pt-1 pl-2 pa-0>
                            Rostered Days
                          </v-flex>
                          <v-flex xs4 pt-1 pa-0>
                            Role
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 v-for="(day, ix) in subscription.current.trackDuty" :key="ix" pa-0>
                    <v-layout v-if="typeof day === 'string'" row wrap pa-1 pl-2>
                      <v-flex xs8 pa-0>
                        <h2 class="subheading" :title="day">{{ formatDate(day, 'words') }}</h2>
                      </v-flex>
                      <v-flex xs4 pa-0>
                        <h2 class="subheading">Volunteer</h2>
                      </v-flex>
                    </v-layout>
                    <v-layout v-else row wrap pa-1 pl-2>
                      <v-flex xs8 pa-0>
                        <h2 class="subheading" :title="day.date">{{ formatDate(day.date, 'words') }}</h2>
                      </v-flex>
                      <v-flex xs4 pa-0>
                        {{(day.isSupervisor ? 'Day Supervisor' : 'Volunteer')}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
               </v-card-text>
              <v-card-text class="pa-0 pt-2" v-else>
                <v-divider class="orange sectionDivider" />
                <v-layout row wrap pt-2 text-xs-center>
                  <v-flex xs12>
                    <strong>You are currently unregistered. Click here to sign up for an annual membership</strong>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn color="success" @click="goto('/register')">
                      sign up for annual registration
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-text v-if="isProfileLoaded && profile.membershipHistory && profile.membershipHistory.length > 0">
                <v-layout mt-2 row wrap>
                  <v-divider class="orange sectionDivider" />
                  <v-flex xs12 mt-2>
                    <h3>Membership History</h3>
                  </v-flex>
                </v-layout>
                <v-layout row wrap mt-2>
                  <v-flex xs12>
                    <v-card pa-0 flat>
                      <v-card-title class="pa-0 cardTitle grey lighten-3">
                        <v-layout row wrap pa-1 pb-2>
                          <v-flex xs2 pt-1 pl-1>
                            Status
                          </v-flex>
                          <v-flex xs4 pt-1>
                            Description
                          </v-flex>
                          <v-flex xs2 pt-1>
                            Start Date
                          </v-flex>
                          <v-flex xs2 pt-1>
                            End Date
                          </v-flex>
                          <v-flex xs2 pt-1>
                            Paid
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row wrap pa-2>
                  <v-flex xs12 v-if="subscription.current" :key="subscription.current.orderId">
                    <v-layout row wrap>
                      <v-flex xs2>
                        current
                      </v-flex>
                      <v-flex xs4>
                        {{subscription.current.name}}
                      </v-flex>
                      <v-flex xs2>
                        {{formatDate(subscription.current.subscriptionStarts)}}
                      </v-flex>
                      <v-flex xs2>
                        {{formatDate(subscription.current.subscriptionEnds)}}
                      </v-flex>
                      <v-flex xs2>
                        {{membershipPaymentPrice(subscription.current.price)}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-for="(item, ix) in history" :key="ix">
                    <v-layout row wrap>
                      <v-flex xs2>
                        {{item.status}}
                      </v-flex>
                      <v-flex xs4>
                        {{item.name}}
                      </v-flex>
                      <v-flex xs2>
                        {{formatDate(item.subscriptionStarts)}}
                      </v-flex>
                      <v-flex xs2>
                        {{formatDate(item.closedDate)}}
                      </v-flex>
                      <v-flex xs2>
                        {{membershipPaymentPrice(item.price)}}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    isSaved () {
      return this.saved
    },
    isProfileLoaded () {
      return (this.profile)
    },
    history () {
      let history = this.profile.membershipHistory || []
      return history.reverse()
    },
    disableRenewBtn () {
      try {
        let now = new Date()
        let soon = new Date(this.subscription.current.subscriptionEnds)
        soon.setMonth(soon.getMonth() - 1)
        return (new Date(now.toDateString()) < new Date(soon.toDateString()))
      } catch (e) {
        return false
      }
    },
    hasMetaChanged () {
      if (this.firstName && this.firstName !== this.user.attributes.given_name) return true
      if (this.lastName && this.lastName !== this.user.attributes.family_name) return true
      if (this.email && this.email !== this.user.attributes.email) return true
      if (this.phoneNumber && '+61' + this.phoneNumber.replace('+61', '') !== this.user.attributes.phone_number) return true
      if (this.street && this.street !== this.getAddress.street) return true
      if (this.suburb && this.suburb !== this.getAddress.suburb) return true
      if (this.postcode && this.postcode !== this.getAddress.postcode) return true
      if (this.state && this.state !== this.getAddress.state) return true
      if (this.secondName && this.secondName !== this.getSecondary.name) return true
      if (this.secondNumber && this.secondNumber !== this.getSecondary.number) return true
      return false
    },
    hasHistory () {
      try {
        return (this.user && this.subscription && this.membershipHistory)
      } catch (e) {
        return false
      }
    },
    ...mapGetters({
      user: 'getUser',
      isActive: 'isActiveSubscription',
      hasRegistered: 'hasUserRegistered',
      subscription: 'getSubscription',
      getSecondary: 'getSecondary',
      getAddress: 'getAddress',
      isCommittee: 'isCommittee',
      isExecutive: 'isExecutive',
      family: 'getAccountMembers',
      profile: 'getProfile'
    })
  },
  methods: {
    membershipPaymentPrice (value = null) {
      let price = value
      if (value) {
        if (price === 'Free') return 'No Charge'
        if (price !== 0 && price !== '0') return `$${price}`
        return ''
      }

      if (!this.subscription || this.subscription.current) return ''
      const types = ['life', 'sponsor']
      if (types.indexOf(this.subscription.type) >= 0) return ''

      return `${this.subscription.current.price}`
    },
    renewalError: function () {
      if (this.isMembershipExpired()) return ['Your Membership Requires Renewal']
    },
    isMembershipClose: function () {
      if (!this.subscription && !this.subscription.current) return false
      let close = new Date(this.subscription.current.subscriptionEnds)
      close.setMonth(close.getMonth() - 1)
      return (new Date() >= close)
    },
    isMembershipExpired: function () {
      if (!this.subscription || !this.subscription.current) return true
      return (new Date() > new Date(this.subscription.current.subscriptionEnds))
    },
    downloadCertificate: async function () {
      this.pdfloading = true
      let result = await this.getCertificate()
      this.pdfloading = false
      if (!result.error && result.pdfLink) {
        console.log('My Cert Link:', result.pdfLink)
        let win = window.open(result.pdfLink, '_blank')
        win.focus()
        return
      }

      alert('An Error occurred generating your certificate. Please wait a few moments and try again')
    },
    ...mapActions({
      updateUser: 'updateUserAttributes',
      getProfile: 'getMemberProfile',
      refreshUser: 'refreshUser',
      updateProfile: 'updateMemberProfile',
      getCertificate: 'getCertificate'
    }),
    goto: function (path) {
      this.$router.push(path)
    },
    memberStatus: function () {
      if (!this.profile.status || this.profile.status === 'unconfirmed') return 'Unconfirmed'
      if (this.profile.status === 'unregistered') return 'Inactive'
      if (this.isMembershipExpired()) return 'Renewal Due'
      return 'Active'
    },
    memberStatusClass: function (member) {
      if (!this.profile.status) return 'unconfirmed'
      if (this.profile.status === 'unregistered') return 'unregistered'
      if (this.isMembershipExpired()) return 'renew'
      return 'active'
    },
    isString (value) {
      return (typeof value === 'string')
    },
    formatDate: function (timestring, format) {
      if (!timestring) return ''

      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let time = new Date(timestring)
      switch (format) {
        case 'words':
          return `${days[time.getDay()]}, ${time.getDate()} ${months[time.getMonth()]} ${time.getFullYear()}`
        case 'date':
          return `${time.getDate()}/${time.getMonth() + 1}/${time.getFullYear()}`
        case 'since':
          let newFormat = `${time.getDate()}/${time.getMonth() + 1}/${time.getFullYear()}`
          let nowYear = new Date().getFullYear()
          let yearDiff = nowYear - time.getFullYear()
          if (yearDiff === 0) return newFormat
          if (yearDiff === 1) return newFormat + ' (1 Year)'
          return newFormat + ` (${yearDiff} Years)`
        default:
          return `${time.getDate()}/${time.getMonth() + 1}/${time.getFullYear()}`
      }
    },
    saveChanges: async function () {
      console.log('Save Changes to Profile')
      if (!this.hasMetaChanged) return null
      if (this.saving) return false

      this.saving = true

      let number = this.phoneNumber.replace('+61', '')

      let changes = {
        details: {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email.toLowerCase(),
          phoneNumber: '+61' + number,
          address: {
            street: this.street,
            suburb: this.suburb,
            postcode: this.postcode,
            state: this.state
          },
          secondary: {
            name: this.secondName,
            number: this.secondNumber
          }
        }
      }

      try {
        await this.updateProfile(changes)
        this.saving = false
        this.saved = true
        setTimeout(() => {
          this.saved = false
        }, 1000)
      } catch (e) {
        this.saving = false
        this.saved = false
      }
    }
  },
  data () {
    return {
      pdfloading: false,
      saved: false,
      saving: false,
      firstName: null,
      lastName: null,
      secondName: null,
      secondNumber: null,
      email: null,
      phoneNumber: null,
      street: null,
      postcode: null,
      suburb: null,
      state: null,
      includes: [
        {
          icon: 'assignment',
          iconClass: 'success white--text',
          title: 'Family Membership',
          subtitle: 'Parents only need to purchase one membership to cover all their kids'
        },
        {
          icon: 'assignment',
          iconClass: 'warning white--text',
          title: 'Track Access',
          subtitle: 'Only active members are allowed to use the clubs services, including track access'
        },
        {
          icon: 'assignment',
          iconClass: 'blue white--text',
          title: 'Volunteer Duty',
          subtitle: 'Active Members are required to volunteer for Track Duty on at least 2 separate occasions per year'
        }
      ],
      stateItems: ['NT', 'NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA']
    }
  },
  created () {
    this.firstName = this.user.attributes.given_name
    this.lastName = this.user.attributes.family_name
    this.phoneNumber = this.user.attributes.phone_number.replace('+61', '')
    this.email = this.user.attributes.email
    this.street = this.getAddress.street
    this.suburb = this.getAddress.suburb
    this.postcode = this.getAddress.postcode
    this.state = this.getAddress.state
    this.secondName = this.getSecondary.name
    this.secondNumber = this.getSecondary.number
  },
  mounted () {
    this.getProfile()
    this.refreshUser()
  }
}
</script>
<style>
.memberStatus.unconfirmed {
  color: red;
}
.memberStatus.unregistered {
  color: orange;
}
.memberStatus.renew {
  color: orange;
}
.memberStatus.active {
  color: green;
}
.newmembershipSection {
  border: solid 2px #2196f3;
  border-radius: 20px;
}
.sectionDivider {
  border-width: 1px;
}
</style>
